module.exports = __webpack_public_path__ + "static/media/cancel-service_2.66f24fd8.png";